import { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Box } from '@mui/material';
import { ToolContext } from './core/context/ToolContext';
import { WebRoute } from "./core/webrouter/Route";
import { InstallPromotion } from './components/layouts/installation/InstallPromotion';
import { BrandedSplash } from './core/loader/BrandedSplash';
import { VM } from './core/VM';

import dkstpBg from './assets/images/core/bg.png'
import mblBg from "./assets/images/core/bg_mobile.png"

const __SESSION = JSON.parse(localStorage.getItem('pm_tool_session'))

const isPwaShellRoute = () => {
	const path = window.location.pathname || ''
	return /^\/pwa\/(install|continue|launch)\/?$/.test(path)
}

export const Core = () => {
	const { tool_state, install_state } = useContext(ToolContext)
	const q = new URLSearchParams(window.location.search);
	const skipSplash = isPwaShellRoute()
	const [splashDone, setSplashDone] = useState(skipSplash)

	useEffect(() => {
		if (skipSplash) {
			tool_state.prefetch.set(true)
			console.log(`${VM()===''?'desktop':VM()} is the current device`);
			console.log(`POFMain V2.1.76 is running`);
			return undefined
		}

		const id = setTimeout(() => {
			tool_state.prefetch.set(true)
			if (q.get('from') === null) {
				if (__SESSION !== null) {
					localStorage.removeItem('pm_tool_session')
					if (q.get('sainfo') === null || q.get('sainfo') === undefined) {
						window.location.href = window.location.pathname
					}
				}
			}

			console.log(`${VM()===''?'desktop':VM()} is the current device`);
			console.log(`POFMain V2.1.76 is running`);
		}, 1000);

		return () => clearTimeout(id)
		
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// PWA shell gates must not wait on the branded splash / prefetch delay.
	const showApp = skipSplash || (tool_state.prefetch.data && splashDone)

	return (
		<Box width="100%" height="100%" 
			sx={{backgroundColor: '#FFF',
				backgroundImage: skipSplash
					? 'none'
					: `url(${VM()==='/devices/mobile'? mblBg: dkstpBg})`,
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
				backgroundAttachment: 'fixed',
			}}
		>
			{
				showApp ? (
					<Router>
						<Box height="100%" >
							<Box flexGrow={1} height="100%" >
								<WebRoute />
							</Box>
						</Box>
					</Router>
				) : null
			}
			{!skipSplash && !splashDone && (
				<BrandedSplash
					ready={tool_state.prefetch.data}
					onExitComplete={() => setSplashDone(true)}
				/>
			)}
			{!skipSplash && (
				<InstallPromotion install_state={install_state} />
			)}
		</Box>
	)
}
